module.exports = __webpack_public_path__ + "img/13-small.59fcdc7c.png";